import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../config';

const STEP_LABEL = { n456: '456', copertura: 'Copertura', lucchetto: 'Lucchetto' };
const badge = (color) => ({ fontSize: 11, fontWeight: 800, padding: '2px 8px', borderRadius: 999,
  color: '#fff', background: color, whiteSpace: 'nowrap' });

export default function VerificaDominio() {
  const [dominio, setDominio] = useState('');
  const [job, setJob] = useState(null);
  const [busy, setBusy] = useState(false);
  const poll = useRef(null);

  useEffect(() => () => clearInterval(poll.current), []);

  const avvia = async () => {
    const d = dominio.trim();
    if (!d) return;
    setBusy(true); setJob(null);
    clearInterval(poll.current);
    try {
      const r = await axios.post(`${API}/dominio/verifica`, { dominio: d });
      const id = r.data.job_id;
      poll.current = setInterval(async () => {
        try {
          const s = await axios.get(`${API}/dominio/verifica/${id}`);
          setJob(s.data);
          if (s.data.stato === 'completato' || s.data.stato === 'errore') {
            clearInterval(poll.current); setBusy(false);
          }
        } catch { /* ritenta */ }
      }, 1500);
    } catch (e) {
      setBusy(false); toast.error(e.response?.data?.detail || 'Errore avvio');
    }
  };

  const dati = job?.dati || {};
  const step = job?.step || {};
  const statoStep = (s) => {
    if (!s) return <span style={{ color: '#94a3b8' }}>—</span>;
    if (s.stato === 'in_corso' || s.stato === 'attesa') return <span style={{ color: '#64748b' }}>in corso…</span>;
    if (s.stato === 'saltato') return <span style={{ color: '#94a3b8' }}>saltato · {s.motivo}</span>;
    if (s.stato === 'errore') return <span style={{ color: '#ef4444' }}>errore · {s.motivo}</span>;
    if (s.fonte) return (
      <span style={{ color: '#0f172a', fontWeight: 700 }} title={s.motivo || ''}>
        {s.esito || 'fatto'}
        <span style={{ fontWeight: 500, color: '#64748b', marginLeft: 6 }}>via {s.fonte}</span>
      </span>
    );
    return <span style={{ color: '#0f172a', fontWeight: 700 }}>{s.esito || 'fatto'}</span>;
  };

  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <h2 style={{ marginTop: 0 }}>Verifica dominio</h2>
      <p style={{ color: '#64748b', fontSize: 13, marginTop: 0 }}>
        Inserisci un dominio: recupero P.IVA, indirizzo e telefono, poi lancio 456, Copertura e Lucchetto.
      </p>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <input className="in" style={{ flex: 1, minWidth: 220 }} placeholder="es. azienda.it"
          value={dominio} onChange={e => setDominio(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') avvia(); }} />
        <button className="btn btn-primary" disabled={busy || !dominio.trim()} onClick={avvia}>
          {busy ? 'In corso…' : 'Avvia'}
        </button>
      </div>

      {job && (
        <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, fontSize: 13 }}>
            <div><b>Ragione sociale:</b> {dati.ragione_sociale || '—'}</div>
            <div><b>P.IVA:</b> {dati.partita_iva || '—'}</div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <b>Telefono:</b> {dati.telefono || '—'}
              {dati.telefono && <span style={badge(dati.telefono_fisso ? '#16a34a' : '#b45309')}>{dati.telefono_tipo || (dati.telefono_fisso ? 'fisso' : 'mobile')}</span>}
            </div>
            <div><b>Indirizzo:</b> {dati.indirizzo || '—'}</div>
          </div>
          <div style={{ border: '1px solid #e5e7eb', borderRadius: 10, overflow: 'hidden' }}>
            {['n456', 'copertura', 'lucchetto'].map(k => (
              <div key={k} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '10px 12px', borderTop: k !== 'n456' ? '1px solid #f1f5f9' : 'none' }}>
                <span style={{ fontWeight: 700 }}>{STEP_LABEL[k]}</span>
                {statoStep(step[k])}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
